import type { IconProps } from './../../models/icon';

export function ChevronDownIcon({
  width = 24,
  height = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M0.856934 6.59998L11.3998 17.1428C11.4767 17.2248 11.5697 17.2901 11.6729 17.3349C11.7761 17.3794 11.8873 17.4026 11.9998 17.4026C12.1122 17.4026 12.2235 17.3794 12.3267 17.3349C12.4299 17.2901 12.5228 17.2248 12.5998 17.1428L23.1426 6.59998"
      />
    </svg>
  );
}
